import React from 'react'
import PromotionListItemForm from './PromotionListItemForm'
import PromotionListLayout from './PromotionListLayout'

const PromotionListItem = ({ item, itemIndex }) => (
  <PromotionListLayout>
    <PromotionListItemForm promotion={item} index={itemIndex} />
  </PromotionListLayout>
)

export default PromotionListItem



// WEBPACK FOOTER //
// ./src/components/templates/promotion-list/PromotionListItem.js